// extracted by mini-css-extract-plugin
export var grid = "_8-5";
export var layout = "_8-0";
export var leftColumn = "_8-1";
export var leftInner = "_8-2";
export var rightColumn = "_8-3";
export var rightInner = "_8-4";